import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const serviceGroupSlice = createSlice({
  name: 'serviceGroup',
  initialState: {
    serviceGroupName: "",
    serviceGroupFile: {} as any,
    routings: [] as any[],
    tags: [] as any[],
    imageUrl: "",
  },
  reducers: {
    setServiceGroupName: (state, action: PayloadAction<string>) => {
      state.serviceGroupName = action.payload;
    },
    setServiceGroupFile: (state, action: PayloadAction<any>) => {
      state.serviceGroupFile = action.payload;
    },
    setServiceGroupRouting: (state, action: PayloadAction<any[]>) => {
      state.routings = action.payload;
    },
    setServiceGroupTag: (state, action: PayloadAction<any[]>) => {
      state.tags = action.payload;
    },
    setImageUrl: (state, action: PayloadAction<string>) => {
      state.imageUrl = action.payload;
    },
  },
});

export const { setServiceGroupName, setServiceGroupFile, setServiceGroupRouting, setServiceGroupTag, setImageUrl } = serviceGroupSlice.actions;

export default serviceGroupSlice.reducer;
